module.exports = __webpack_public_path__ + "img/zhongwu.fb97b94f.png";